import * as React from "react";
import { BreadcrumbItem } from "src/appStore";
import { MenuTab2Item, MenuTabs2 } from "src/components/MenuTabs2";
import { PageLayout } from "src/components/PageLayout";
import { ToolBox2 } from "src/components/ToolBox2";
import { PageUrl } from "src/routes/PageUrl";

type RecordFeatureMode = "card" | "history";

type PropsRecordCardCommonBox = {
  mode: RecordFeatureMode;
  children: React.ReactNode;
  recordId: string;
  title: BreadcrumbItem[];
};

export const RecordCardCommonBox: React.FC<PropsRecordCardCommonBox> = (
  props,
) => {
  const { mode, children, recordId, title } = props;
  const tabs: Record<RecordFeatureMode, MenuTab2Item> = {
    card: {
      label: "Карточка",
      page: PageUrl.editRecord,
      params: { id: recordId },
    },
    history: {
      label: "История изменений",
      page: PageUrl.recordHistory,
      params: { id: recordId },
    },
  };
  return (
    <PageLayout title={title}>
      <ToolBox2 mainTool={<MenuTabs2 activeTab={mode} tabs={tabs} />}>
        {children}
      </ToolBox2>
    </PageLayout>
  );
};
